import { Action } from '../actions'
import { DetailViewAction, ScreenSizeAction } from '../constants'
import { IDetailViewState, InitialState } from '../state'
export const detailView = (
  state: IDetailViewState = InitialState.detailView(),
  action: Action
): IDetailViewState => {
  switch (action.type) {
    case DetailViewAction.SET_DETAIL_VISIBILITY:
      return {
        ...state,
        isDetailViewVisible: action.isVisible,
      }
    case ScreenSizeAction.SET_PHONE_SIZE:
      return {
        ...state,
        isSmallScreen: true,
      }
    case ScreenSizeAction.SET_TABLET_PORTRAIT_SIZE:
    case ScreenSizeAction.SET_TABLET_LANDSCAPE_SIZE:
    case ScreenSizeAction.SET_DESKTOP_SIZE:
    case ScreenSizeAction.SET_DESKTOP_BIG_SIZE:
      return {
        ...state,
        isSmallScreen: false,
      }
    default:
      return state
  }
}
